module.exports = __webpack_public_path__ + "354e9d40.png";